import React, { useMemo } from 'react';

const CapacityPressurePanel = ({ items = [] }) => {
  const ranked = useMemo(
    () => [...items].sort((a, b) => Number(b?.capacityPressureScore || 0) - Number(a?.capacityPressureScore || 0)).slice(0, 6),
    [items],
  );

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/80 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Tekanan Kapasitas</h3>
      <div className="mt-3 space-y-2">
        {ranked.length === 0 ? <p className="text-xs text-slate-500">Belum ada data.</p> : ranked.map((row) => (
          <div key={row.candidateId} className="flex items-center justify-between rounded-md border border-slate-800 bg-slate-950/70 px-3 py-2 text-xs">
            <span className="text-slate-300">{row.scopeType} • {row.scopeKey}</span>
            <span className="font-semibold text-amber-300">{Number(row.capacityPressureScore || 0).toFixed(1)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CapacityPressurePanel;
